const ResizeIcon = () => {
  return (
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 12L6 17L11 12M1 6L6 1L11 6" stroke="#A2A2A2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ResizeIcon;
